import React from "react";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const CP_BACKEND = process.env.REACT_APP_BACKEND_URL;
const fmtBRLp = (v) => new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(Number(v) || 0);
export const precoCat = (p) => (p.preco_promocional && p.preco_promocional < p.preco ? p.preco_promocional : p.preco);

export function CatalogPicker({ loja, index, onSelect }) {
  const [open, setOpen] = React.useState(false);
  const [prods, setProds] = React.useState([]);
  const [busca, setBusca] = React.useState("");
  const [cat, setCat] = React.useState("");
  React.useEffect(() => {
    if (open && loja) {
      axios.get(`${CP_BACKEND}/api/catalogo/vitrine`, { params: { loja } }).then((r) => setProds(r.data.produtos || [])).catch(() => setProds([]));
    }
  }, [open, loja]);
  const disponiveis = prods.filter((p) => p.exibir_catalogo !== false && (p.quantidade_catalogo === undefined || p.quantidade_catalogo === null || p.quantidade_catalogo > 0));
  const cats = [...new Set(disponiveis.map((p) => p.categoria).filter(Boolean))];
  const filtrados = disponiveis.filter((p) => {
    const q = busca.toLowerCase();
    const okq = !q || (p.nome || "").toLowerCase().includes(q) || (p.codigo || "").toLowerCase().includes(q) || (p.categoria || "").toLowerCase().includes(q);
    return okq && (!cat || p.categoria === cat);
  });
  return (
    <>
      <Button type="button" variant="outline" size="sm" className="mt-3" onClick={() => setOpen(true)} disabled={!loja} data-testid={`btn-catalogo-${index}`}>
        <Search className="w-4 h-4 mr-1" /> Selecionar do Catálogo
      </Button>
      {!loja && <span className="text-xs text-amber-600 ml-2">Selecione a loja da venda primeiro</span>}
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="sm:max-w-2xl bg-white max-h-[85vh] overflow-y-auto" data-testid="catalogo-picker">
          <DialogHeader><DialogTitle>Catálogo — {loja}</DialogTitle></DialogHeader>
          <Input placeholder="Buscar por referência, nome ou categoria" value={busca} onChange={(e) => setBusca(e.target.value)} data-testid="catalogo-picker-busca" />
          <div className="flex flex-wrap gap-1.5 my-2">
            <button type="button" onClick={() => setCat("")} className={`px-2.5 py-1 rounded-full text-xs font-medium ${!cat ? "bg-slate-900 text-white" : "bg-slate-100 text-slate-600"}`}>Todas</button>
            {cats.map((c) => (<button type="button" key={c} onClick={() => setCat(c)} className={`px-2.5 py-1 rounded-full text-xs font-medium ${cat === c ? "bg-slate-900 text-white" : "bg-slate-100 text-slate-600"}`}>{c}</button>))}
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
            {filtrados.length === 0 && <p className="col-span-full text-center text-slate-400 py-6 text-sm">Nenhum produto no catálogo desta loja.</p>}
            {filtrados.map((p) => (
              <button type="button" key={p.id} onClick={() => { onSelect(p); setOpen(false); }} className="text-left border border-slate-200 rounded-lg p-2 hover:border-slate-900 transition-colors" data-testid={`catalogo-pick-${p.id}`}>
                <div className="aspect-square bg-white rounded flex items-center justify-center overflow-hidden mb-1">
                  {p.foto_url ? <img src={`${CP_BACKEND}${p.foto_url}`} alt="" className="w-full h-full object-contain" /> : <span className="text-slate-300 text-xs">sem foto</span>}
                </div>
                <p className="text-xs font-semibold truncate">{p.nome}</p>
                <p className="text-[10px] text-slate-400">Ref: {p.codigo || "-"}</p>
                <p className="text-xs font-bold text-emerald-600">{fmtBRLp(precoCat(p))}</p>
              </button>
            ))}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
